<mat-dropdown
  [formControl]="formControl()"
  [options]="dropdownOptions"
  [configurationInput]="dropdownConfiguration"
  [isFormSubmitted]="isFormSubmitted()"
></mat-dropdown>
